import { DefaultTheme } from 'styled-components'

const chatTheme: DefaultTheme = {
  borderRadius: '5px',
  colors: {
    main: '#0FACF3',
    secondary: '#D7263D',
    third: '#D7263D',
    background: '#f2f5f7'
  },
  font: {
    primary: 'rgba(0,0,0,.87)',
    sub: 'rgba(0,0,0,.54)'
  }
}

export {chatTheme};